import React from 'react';

function Minus16(props) {
	const fill = props.fill || 'currentColor';
	const secondaryfill = props.secondaryfill || fill;
	const width = props.width || '100%';
	const height = props.height || '100%';
	const title = props.title || "minus 16";

	return (
		<svg height={height} width={width} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
	<title>{title}</title>
	<g fill={secondaryfill} stroke={secondaryfill} strokeWidth="1">
		<line fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" x1="1.5" x2="15.5" y1="8.5" y2="8.5"/>
	</g>
</svg>
	);
};

export default Minus16;